export function validateChoiceLimit({
  selected,
  choiceLimit,
  choiceLimitNumber,
  choiceLimitMin,
  choiceLimitMax,
}: {
  selected: string[]
  choiceLimit: string
  choiceLimitNumber?: string
  choiceLimitMin?: string
  choiceLimitMax?: string
}): string | null {
  const count = selected.length

  if (choiceLimit === "exactly" && choiceLimitNumber) {
    const exact = parseInt(choiceLimitNumber, 10)
    if (count !== exact) return `Please select exactly ${exact} option${exact > 1 ? "s" : ""}.`
  }

  if (choiceLimit === "range") {
    const min = parseInt(choiceLimitMin || "0", 10)
    const max = parseInt(choiceLimitMax || "0", 10)

    if (min && count < min) return `Please select at least ${min} option${min > 1 ? "s" : ""}.`
    if (max && count > max) return `Please select no more than ${max} option${max > 1 ? "s" : ""}.`
  }

  return null
}
